import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminLayout from './layouts/AdminLayout';
import Dashboard from './pages/Dashboard';
import EstablishmentList from './pages/EstablishmentList';
import EstablishmentEdit from './pages/EstablishmentEdit';
import EventsList from './pages/EventsList';
import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext';
import EventEdit from './pages/EventEdit';
import CategoriesList from './pages/CategoriesList';
import CategoryEdit from './pages/CategoryEdit';
import TagsList from './pages/TagsList';
import TagsEdit from './pages/TagsEdit';
import EmergencyInformation from './pages/EmergencyInformation';
import RecommendationArticlesList from './pages/RecommendationArticlesList';
import RecommendationArticleEdit from './pages/RecommendationArticleEdit';
import PartnerAdEdit from './pages/PartnerAdEdit';
import PartnerAdsList from './pages/PartnerAdsList';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAdminAuth();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

const AdminApp = () => {
  return (
    <AdminAuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<AdminLogin />} />
          <Route path="/" element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/establishments" element={
            <ProtectedRoute>
              <AdminLayout>
                <EstablishmentList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/establishments/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <EstablishmentEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/events" element={
            <ProtectedRoute>
              <AdminLayout>
                <EventsList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/events/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <EventEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/categories" element={
            <ProtectedRoute>
              <AdminLayout>
                <CategoriesList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/categories/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <CategoryEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/tags" element={
            <ProtectedRoute>
              <AdminLayout>
                <TagsList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/tags/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <TagsEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/emergency" element={
            <ProtectedRoute>
              <AdminLayout>
                <EmergencyInformation />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/recommendation-articles" element={
            <ProtectedRoute>
              <AdminLayout>
                <RecommendationArticlesList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/recommendation-articles/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <RecommendationArticleEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/partner-ads" element={
            <ProtectedRoute>
              <AdminLayout>
                <PartnerAdsList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/partner-ads/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <PartnerAdEdit />
              </AdminLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </AdminAuthProvider>
  );
};

export default AdminApp;